export enum BankAccountTypesEnum {
    Iban = 1,
    BankAccount,
    SortCode,
    CryptoWallet
}
